exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: #ffffff;\n  background-image: url(" + require("./bg.png") + ");\n  background-size: cover;\n  justify-content: center;\n  align-items: center;\n}\n.login > div {\n  width: 920px;\n  height: 520px;\n  background: #ffffff;\n  border-radius: 8px;\n  display: flex;\n  overflow: hidden;\n}\n.login .login-title {\n  height: 100%;\n  width: 390px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #ededed;\n}\n.login .login-form {\n  width: 260px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n.login .login-form h3 {\n  font-size: 16px;\n  font-weight: bold;\n}\n.login .login-form-forgot {\n  float: right;\n}\n.login .login-form-button {\n  width: 100%;\n}\n.login .create-form-button {\n  width: 210px;\n  height: 48px;\n  font-size: 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/login/index.less
// module id = 800
// module chunks = 0